import { render } from "./FileElement.vue?vue&type=template&id=b9e38ad2"
import script from "./FileElement.vue?vue&type=script&lang=js"
export * from "./FileElement.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kl_keepjoy_work/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__